const GroupType = {
  ENTITY_LIST: 'ENTITY_LIST',
  CUSTOM: 'CUSTOM',
  PRODUCT: 'PRODUCT',
  MANAGER: 'MANAGER',
  INVEST_PLATFORM: 'INVEST_PLATFORM',
  CLIENT_PORTFOLIO_MGR: 'CLIENT_PORTFOLIO_MANAGER',
  COMPOSITE: 'COMPOSITE',
  GROUPS: 'GROUPS'
};

const GroupTypeEntity = {

  [GroupType.CUSTOM]: {
    value: GroupType.CUSTOM,
    label: 'Custom Account Group',
    groupingValue: 'custom',
    emsValue: 'custom_group',
    emsEndpoint: 'getCustomGroups',
    emsGroupValueKey: 'id',
    emsGroupLabelKey: 'description',
    groupPickerColumnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        width: 60,
        suppressSizeToFit: true
      },
      {
        headerName: 'Investment Team',
        field: 'investmentTeam',
        width: 250,
        suppressSizeToFit: true
      },
      {
        headerName: 'Description',
        field: 'description'
      }
    ],
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.investmentTeam === o2.investmentTeam) {
        if (o1.description === o2.description) {
          return 0;
        }
        if (!o1.description) {
          return -1;
        }
        if (!o2.description) {
          return 1;
        }
        return o1.description > o2.description ? 1 : -1;
      }
      if (!o1.investmentTeam || o1.investmentTeam === '') {
        return 1;
      }
      if (!o2.investmentTeam || o2.investmentTeam === '') {
        return -1;
      }
      return o1.investmentTeam > o2.investmentTeam ? 1 : -1;
    }
  },
  [GroupType.PRODUCT]: {
    value: GroupType.PRODUCT,
    label: 'Product',
    groupingValue: 'product',
    emsValue: 'product',
    emsEndpoint: 'getProducts',
    emsGroupValueKey: 'id',
    emsGroupLabelKey: 'description',
    groupPickerColumnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        width: 60,
        suppressSizeToFit: true
      },
      {
        headerName: 'Product',
        field: 'description',
        width: 250
      }
    ],
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.description === o2.description) {
        return 0;
      }
      if (!o1.description) {
        return -1;
      }
      if (!o2.description) {
        return 1;
      }
      return o1.description > o2.description ? 1 : -1;
    }
  },
  [GroupType.MANAGER]: {
    value: GroupType.MANAGER,
    label: 'Manager',
    groupingValue: 'manager',
    emsValue: 'manager',
    emsEndpoint: 'getManagers',
    emsGroupValueKey: 'id',
    emsGroupLabelKey: 'lastName',
    groupPickerColumnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        width: 60,
        suppressSizeToFit: true
      },
      {
        headerName: 'Last Name',
        field: 'lastName'
      },
      {
        headerName: 'First Name',
        field: 'firstName'
      }
    ],
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.lastName === o2.lastName) {
        if (o1.firstName === o2.firstName) {
          return 0;
        }
        if (!o1.firstName) {
          return -1;
        }
        if (!o2.firstName) {
          return 1;
        }
        return o1.firstName > o2.firstName ? 1 : -1;
      }
      if (!o1.lastName || o1.lastName === '') {
        return 1;
      }
      if (!o2.lastName || o2.lastName === '') {
        return -1;
      }
      return o1.lastName > o2.lastName ? 1 : -1;
    }
  },
  [GroupType.INVEST_PLATFORM]: {
    value: GroupType.INVEST_PLATFORM,
    label: 'Investment Platform',
    groupingValue: 'invest_platform',
    emsValue: 'invest_platform',
    emsEndpoint: 'getInvestPlatforms',
    emsGroupValueKey: 'id',
    emsGroupLabelKey: 'desc',
    groupPickerColumnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        width: 60,
        suppressSizeToFit: true
      },
      {
        headerName: 'Investment Platform',
        field: 'desc',
        width: 250
      }
    ],
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.desc === o2.desc) {
        return 0;
      }
      if (!o1.desc) {
        return -1;
      }
      if (!o2.desc) {
        return 1;
      }
      return o1.desc > o2.desc ? 1 : -1;
    }
  },
  [GroupType.CLIENT_PORTFOLIO_MGR]: {
    value: GroupType.CLIENT_PORTFOLIO_MGR,
    label: 'Client Portfolio Manager',
    groupingValue: 'client_portfolio_manager',
    emsValue: 'clientPortfolioManager ',
    emsEndpoint: 'getClientPortfolioManagers',
    emsGroupValueKey: 'id',
    emsGroupLabelKey: 'lastName',
    groupPickerColumnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        width: 60,
        suppressSizeToFit: true
      },
      {
        headerName: 'Last Name',
        field: 'lastName'
      },
      {
        headerName: 'First Name',
        field: 'firstName'
      }
    ],
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.lastName === o2.lastName) {
        if (o1.firstName === o2.firstName) {
          return 0;
        }
        if (!o1.firstName) {
          return -1;
        }
        if (!o2.firstName) {
          return 1;
        }
        return o1.firstName > o2.firstName ? 1 : -1;
      }
      if (!o1.lastName || o1.lastName === '') {
        return 1;
      }
      if (!o2.lastName || o2.lastName === '') {
        return -1;
      }
      return o1.lastName > o2.lastName ? 1 : -1;
    }
  },
  [GroupType.COMPOSITE]: {
    value: GroupType.COMPOSITE,
    label: 'Composite Groups',
    groupingValue: 'comp',
    emsGroupValueKey: 'entityId',
    comboboxValueKey: 'entityId',
    emsGroupLabelKey: 'name',
    groupPickerColumnDefs: [
      {
        headerName: 'Entity ID',
        field: 'entityId',
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: 'Name',
        field: 'name',
      },
    ],
    /*
    fetchGroups: async ({asOfDate}) => {
      const request = await window.fetch(`${process.env.REACT_APP_BASE_URL_ENTITY_SERVICE}/rest/query/type/Attributes.json?entityDates=${asOfDate}&select=entityId,name&where=type+%3D+%27COMP%27`);
      const json = await request.json();

      return json?.results ?? [];
    },
    */
    groupTypeGroupSorter: (o1, o2) => {
      return o1.name > o2.name ? 1 : -1;
    },
  },

  [GroupType.GROUPS]: {
    value: GroupType.GROUPS,
    label: 'Entity Groups',
    groupingValue: 'comp',
    emsGroupValueKey: 'entityId',
    comboboxValueKey: 'entityId',
    emsGroupLabelKey: 'name',
    groupPickerColumnDefs: [
      {
        headerName: 'Entity ID',
        field: 'entityId',
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: 'Name',
        field: 'name',
      },
    ],
    /*
    fetchGroups: async ({asOfDate}) => {
      const request = await window.fetch(`${process.env.REACT_APP_BASE_URL_ENTITY_SERVICE}/rest/query/type/Attributes.json?entityDates=${asOfDate}&select=entityId,name&where=type+%3D+%27COMP%27`);
      const json = await request.json();

      return json?.results ?? [];
    },
    */
    groupTypeGroupSorter: (o1, o2) => {
      return o1.name > o2.name ? 1 : -1;
    },
  },



  
};

export default GroupType;
export { GroupTypeEntity };
